/**
 * Script handle site top navigation
 */

(function ($) {
    'use strict';

    function initMenu() {
        var navigation, menu, button, body;
        navigation = $('#site-navigation');


        if (navigation.length <= 0)
            return false;

        button = $('#top-nav-icon');
        menu = navigation.find('ul');
        body = $('body');

        button.attr('aria-expanded', false);

        button.on('click', function () {
            if (body.hasClass('toggled')) {
                button.attr('aria-expanded', false);
                menu.attr('aria-expanded', false);

                $(window).bind('unbind', keyCode);

            } else {
                button.attr('aria-expanded', true);
                menu.attr('aria-expanded', true);

                $(window).bind('keyup', keyCode);
            }

            $('body').toggleClass('toggled');
        });

        navigation.on('click', function () {
            if (body.hasClass('toggled')){
                button.click();
            }
        });

        /**
         * Button etc, cancel menu
         * @param e
         */
        function keyCode(e){
            if (body.hasClass('toggled') && e.keyCode == 27){
                button.click();
            }
        }
    }

    initMenu();

})(jQuery);